import React from "react";

import Button from "../../Button/Button";

export interface TableV2IconButtonProps {
  icon: string;
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /** Shows `label` as a tooltip. Off for repeated row controls */
  tooltip?: boolean;
  /** Highlighted, e.g. while its panel is open */
  active?: boolean;
  /** Keeps its space but isn't shown, so neighbours stay aligned */
  hidden?: boolean;
  disabled?: boolean;
  /** Defaults to `label` in kebab case, e.g. "next-page" */
  testId?: string;
}

export const toTestId = (text: string) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

// 24px square so rows, chips and the header overlay keep their height; never squeezed by a narrow flex parent
const SQUARE: React.CSSProperties = {
  boxSizing: "border-box",
  width: 24,
  height: 24,
  flexShrink: 0,
  paddingLeft: 0,
  paddingRight: 0,
  justifyContent: "center",
};

const TableV2IconButton = ({
  icon,
  label,
  onClick,
  tooltip = true,
  active = false,
  hidden = false,
  disabled,
  testId,
}: TableV2IconButtonProps) => (
  <Button
    small
    variant={active ? "link" : "neutralLink"}
    icon={icon}
    tooltip={tooltip ? label : undefined}
    disabled={disabled}
    onClick={onClick}
    testId={testId ?? toTestId(label)}
    style={{
      ...SQUARE,
      ...(hidden ? { visibility: "hidden" } : undefined),
    }}
  />
);

export default TableV2IconButton;
